<template>
  <div>
  <a-drawer
    :visible="visible"
    placement="right"
    :width="'80%'"
    :title="drawerTitle"
    :closable="true"
    @close="onClose"
  >
    <div class="vod-question-page">
    <!-- ===== 点位列表（仅当前问卷的点位） ===== -->
    <div class="toolbar">
      <a-select v-model="pFilter.sourceType" placeholder="来源类型" allow-clear style="width: 170px">
        <a-select-option value="VOD_SINGLE">VOD_SINGLE 单视频</a-select-option>
        <a-select-option value="MIX_SET_TOPIC">MIX_SET_TOPIC 专题子条目</a-select-option>
      </a-select>
      <a-input v-model="pFilter.videoTitle" placeholder="视频标题搜索" allow-clear style="width: 200px; margin-left: 8px" @keyup.enter="loadPoints(1)" />
      <a-button type="primary" style="margin-left: 8px" @click="loadPoints(1)">搜索</a-button>
      <a-button type="primary" icon="plus" style="float: right" @click="openPointModal()">新增点位</a-button>
    </div>
    <a-table
      :columns="pointColumns"
      :data-source="points"
      row-key="id"
      size="middle"
      :loading="pLoading"
      :scroll="{ x: 1000 }"
      :pagination="{ current: pPage, pageSize: pPageSize, total: pTotal, showSizeChanger: false }"
      @change="onPTableChange"
    >
      <template slot="qTitle" slot-scope="text, record">
        {{ qTitleOf(record) }}
        <span class="mono">#{{ record.questionnaireId }}</span>
      </template>
      <template slot="sourceType" slot-scope="text">
        <a-tag :color="text === 'VOD_SINGLE' ? 'blue' : 'purple'">{{ text }}</a-tag>
      </template>
      <template slot="source" slot-scope="text, record">
        <a v-if="record.videos && record.videos.length > 1" class="vp-video-link" @click="openVideos(record)">{{ record.videos.length }} 个子视频</a>
        <b v-else>{{ record.sourceTitle || ('ID ' + record.sourceId) }}</b>
      </template>
      <template slot="topic" slot-scope="text, record">
        <span v-if="record.topicTitle">{{ record.topicTitle }}</span>
        <span v-else class="cfg-hint">—</span>
      </template>
      <template slot="status" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '禁用' }}</a-tag>
      </template>
      <template slot="triggerTime" slot-scope="text">
        <b>{{ text }}</b>s
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button size="small" @click="togglePointStatus(record.pointIds || [record.id], record.status === 1 ? 0 : 1)">
          {{ record.status === 1 ? '禁用' : '启用' }}
        </a-button>
        <a-button size="small" style="margin-left: 6px" @click="openPointModal(record)">编辑</a-button>
        <a-popconfirm title="确认删除该点位？作答记录保留" @confirm="delPoint(record.pointIds || [record.id])">
          <a-button size="small" type="danger" style="margin-left: 6px">删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- ===== 点位 新增/编辑 弹窗 ===== -->
    <a-modal :visible="pModal.visible" :title="pModal.id ? (pForm.sourceType === 'MIX_SET_TOPIC' ? '编辑点位（专题组 ' + selectedVideoIds.length + ' 个视频）' : '编辑点位 #' + pModal.id) : '新增点位'" width="680px" @cancel="closePModal" @ok="savePoint" :confirm-loading="pModal.saving">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="来源类型">
          <a-radio-group v-model="pForm.sourceType" @change="onPTypeChange">
            <a-radio value="VOD_SINGLE">VOD_SINGLE 单视频</a-radio>
            <a-radio value="MIX_SET_TOPIC">MIX_SET_TOPIC 专题子条目</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 专题选择：仅 MIX_SET_TOPIC -->
        <a-form-model-item v-if="pForm.sourceType === 'MIX_SET_TOPIC'" label="选择专题" required>
          <a-select
            v-model="selectedTopicId"
            show-search
            placeholder="输入专题名称搜索"
            :filter-option="false"
            :not-found-content="topicLoading ? '加载中…' : '未找到匹配专题'"
            style="width: 300px"
            @search="debouncedTopicSearch"
            @change="onTopicPicked"
          >
            <a-select-option v-for="t in topicOptions" :key="t.id" :value="t.id">{{ t.title }} #{{ t.id }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="pForm.sourceType === 'MIX_SET_TOPIC' ? '选择子视频（可多选）' : '选择视频'" required>
          <a-select
            v-model="selectedVideoIds"
            mode="multiple"
            show-search
            :filter-option="videoFilterOption"
            :placeholder="pForm.sourceType === 'MIX_SET_TOPIC' ? '点击展开该专题全部子视频，可输入搜索' : '输入视频标题搜索'"
            :not-found-content="videoLoading ? '加载中…' : (pForm.sourceType === 'MIX_SET_TOPIC' && !selectedTopicId ? '请先在上方选择专题' : '未找到匹配视频')"
            style="width: 360px"
            :loading="videoLoading"
            @search="onVideoSearchInput"
            @change="onVideoChange"
            @dropdownVisibleChange="onVideoDropdownOpen"
          >
            <a-select-option v-for="v in videoOptions" :key="v.id" :value="v.id">{{ v.title }} <template v-if="v.topicTitle">（{{ v.topicTitle }}）</template> #{{ v.id }}</a-select-option>
          </a-select>
          <div class="cfg-hint" style="margin-top: 4px">
            <template v-if="selectedVideos.length">已选 {{ selectedVideos.length }} 个：{{ selectedVideos.map(v => v.title).join('、') }}</template>
            <template v-else>未选择</template>
          </div>
        </a-form-model-item>

        <a-form-model-item label="关联问卷" required>
          <a-select v-model="pForm.questionnaireId" show-search option-filter-prop="label" placeholder="选择问卷" style="width: 300px">
            <a-select-option v-for="q in questionnaireOptions" :key="q.id" :value="q.id" :label="q.id + ' · ' + q.title">{{ q.id }} · {{ q.title }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="触发秒数" required>
          <a-input-number v-model="pForm.triggerTime" :min="0" style="width: 200px" />
          <span class="cfg-hint" style="margin-left: 8px">播放到该秒弹窗；跳过不算已操作，下次进入仍会触发</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    </div>
  </a-drawer>

  <!-- 子视频列表弹窗（点击"N 个子视频"展开；只显示序号+标题，不显示专题名称） -->
  <a-modal :visible="videoListVisible" :title="videoListTitle" :footer="null" width="480px" @cancel="videoListVisible = false">
    <div v-for="(v, i) in videoListVideos" :key="i" class="vp-video-item">
      <span class="mono">{{ i + 1 }}.</span>
      <span>{{ v.title || ('ID ' + v.id) }}</span>
    </div>
  </a-modal>
  </div>
</template>

<script>
import { get, post, put, del } from './api'

export default {
  name: 'VodPointDrawer',
  props: {
    visible: { type: Boolean, default: false },
    questionnaireId: { type: [Number, String], default: null },
    questionnaireTitle: { type: String, default: '' }
  },
  data() {
    return {
      points: [],
      pLoading: false,
      pPage: 1,
      pPageSize: 10,
      pTotal: 0,
      pFilter: { sourceType: undefined, videoTitle: '' },

      pModal: { visible: false, id: null, pointIds: null, saving: false },
      pForm: { sourceType: 'VOD_SINGLE', questionnaireId: undefined, triggerTime: undefined },
      questionnaireOptions: [],
      topicOptions: [],
      videoOptions: [],
      selectedTopicId: undefined,
      selectedTopic: null,
      selectedVideoIds: [],
      selectedVideos: [],
      topicLoading: false,
      videoLoading: false,
      topicSearchTimer: null,
      videoSearchTimer: null,
      videoListVisible: false,
      videoListVideos: []
    }
  },
  computed: {
    drawerTitle() {
      return (this.questionnaireTitle ? this.questionnaireTitle : '问卷 #' + this.questionnaireId) + ' · 视频点位'
    },
    videoListTitle() {
      return '子视频列表（共 ' + this.videoListVideos.length + ' 个）'
    },
    pointColumns() {
      return [
        { title: '问卷名称', key: 'qTitle', width: 200, scopedSlots: { customRender: 'qTitle' } },
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '来源类型', dataIndex: 'sourceType', width: 140, scopedSlots: { customRender: 'sourceType' } },
        { title: '所属专题', key: 'topic', width: 160, scopedSlots: { customRender: 'topic' } },
        { title: '视频/子视频', key: 'source', width: 220, scopedSlots: { customRender: 'source' } },
        { title: '状态', dataIndex: 'status', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '触发时间', dataIndex: 'triggerTime', width: 100, scopedSlots: { customRender: 'triggerTime' } },
        { title: '创建时间', dataIndex: 'createdTime', width: 170 },
        { title: '操作', key: 'action', width: 220, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.pFilter = { sourceType: undefined, videoTitle: '' }
        this.loadPoints(1)
      }
    }
  },
  methods: {
    qTitleOf(record) {
      return record.questionnaireTitle || '—'
    },

    /* 点击"N 个子视频"展开子视频列表 */
    openVideos(record) {
      this.videoListVideos = (record.videos || []).slice()
      this.videoListVisible = true
    },

    /* ===== 点位列表 ===== */
    loadPoints(page) {
      this.pLoading = true
      get('/vod/questionnaire/point/list', {
        questionnaireId: this.questionnaireId || undefined,
        sourceType: this.pFilter.sourceType || undefined,
        videoTitle: this.pFilter.videoTitle || undefined,
        pageNum: page || 1,
        pageSize: this.pPageSize
      }).then(body => {
        this.points = body.data || []
        this.pTotal = body.count != null ? body.count : this.points.length
        this.pPage = page || 1
      }).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.pLoading = false
      })
    },
    onPTableChange(pagination) {
      this.loadPoints(pagination.current)
    },
    // 批量启用/禁用（合并行：同一专题组整组操作）
    togglePointStatus(ids, status) {
      const list = Array.isArray(ids) ? ids : [ids]
      const chain = list.reduce((p, id) => p.then(() => put('/vod/questionnaire/point', { id: id, status: status })), Promise.resolve())
      chain.then(() => {
        this.$message.success(status === 1 ? '已启用' : '已禁用')
        this.loadPoints(this.pPage)
      }).catch(e => this.$message.error(e.message))
    },
    // 批量删除（合并行：同一专题组整组删除，作答记录保留）
    delPoint(ids) {
      const list = Array.isArray(ids) ? ids : [ids]
      const chain = list.reduce((p, id) => p.then(() => del('/vod/questionnaire/point/' + id)), Promise.resolve())
      chain.then(() => {
        this.$message.success('已删除')
        this.loadPoints(this.pPage)
      }).catch(e => this.$message.error(e.message))
    },

    /* ===== 点位弹窗 ===== */
    loadQuestionnaireOptions() {
      get('/vod/questionnaire/list', { pageNum: 1, pageSize: 200 }).then(body => {
        this.questionnaireOptions = body.data || []
      }).catch(e => this.$message.error('问卷下拉加载失败：' + e.message))
    },
    openPointModal(record) {
      if (!record) {
        // ===== 新增点位 =====
        this.pModal.id = null
        this.pModal.pointIds = null
        // 从问卷抽屉进来：新增点位默认绑定当前问卷
        this.pForm = { sourceType: 'VOD_SINGLE', questionnaireId: this.questionnaireId, triggerTime: undefined }
        this.selectedTopicId = undefined
        this.selectedTopic = null
        this.topicOptions = []
        this.selectedVideoIds = []
        this.selectedVideos = []
        this.videoOptions = []
        this.pModal.visible = true
        this.loadQuestionnaireOptions()
        return
      }
      // ===== 编辑点位（合并行：整组回显） =====
      this.pModal.id = record.id || null
      this.pModal.pointIds = record.pointIds || null
      this.pModal.visible = true
      this.loadQuestionnaireOptions()
      this.pForm = {
        sourceType: record.sourceType || 'VOD_SINGLE',
        questionnaireId: record.questionnaireId != null ? record.questionnaireId : this.questionnaireId,
        triggerTime: record.triggerTime != null ? record.triggerTime : undefined
      }
      this.selectedTopicId = record.topicId
      this.selectedTopic = record.topicId ? { id: record.topicId, title: record.topicTitle || '' } : null
      this.topicOptions = record.topicId ? [{ id: record.topicId, title: record.topicTitle || '' }] : []
      const videos = record.videos || []
      this.selectedVideoIds = videos.map(v => v.id)
      this.selectedVideos = videos
      this.videoOptions = videos
    },
    closePModal() {
      if (!this.pModal.saving) this.pModal.visible = false
    },
    onPTypeChange() {
      this.selectedTopic = null
      this.selectedTopicId = undefined
      this.topicOptions = []
      this.selectedVideoIds = []
      this.selectedVideos = []
      this.videoOptions = []
    },
    /* 专题搜索 */
    debouncedTopicSearch(val) {
      clearTimeout(this.topicSearchTimer)
      this.topicSearchTimer = setTimeout(() => this.topicSearch(val), 350)
    },
    topicSearch(val) {
      if (!val) { this.topicOptions = []; return }
      this.topicLoading = true
      get('/vod/questionnaire/video/search', { type: 'MIX_SET_TOPIC', title: val, limit: 20 }).then(body => {
        this.topicOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.topicLoading = false
      })
    },
    onTopicPicked(tid) {
      const t = this.topicOptions.filter(x => x.id === tid)[0]
      if (t) {
        this.selectedTopic = { id: t.id, title: t.title }
      }
      this.selectedVideoIds = []
      this.selectedVideos = []
      // 选中专题后立即加载该专题全部子视频，点击输入框时立即可选
      this.loadAllVideos()
    },
    /* 视频选择：专题下多选（点击展开加载全部子视频，本地过滤搜索）；单视频远程搜索 */
    loadAllVideos() {
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC' || !this.selectedTopicId) return
      this.videoLoading = true
      get('/vod/questionnaire/video/search', { type: 'MIX_SET_TOPIC', topicId: this.selectedTopicId, limit: 500 }).then(body => {
        this.videoOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.videoLoading = false
      })
    },
    onVideoDropdownOpen(open) {
      // 展开时加载该专题全部子视频（新增/编辑都刷新为全部，供搜索和多选）
      if (open && this.pForm.sourceType === 'MIX_SET_TOPIC' && this.selectedTopicId) {
        this.loadAllVideos()
      }
    },
    videoFilterOption(input, option) {
      // MIX_SET_TOPIC：本地过滤全部子视频；VOD_SINGLE：不过滤（走远程搜索）
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC') return true
      const nodes = option.componentOptions && option.componentOptions.children
      const text = (nodes && nodes[0] && nodes[0].text) || ''
      return text.toLowerCase().indexOf((input || '').toLowerCase()) >= 0
    },
    onVideoChange(vids) {
      this.selectedVideos = (vids || []).map(id => this.videoOptions.filter(v => v.id === id)[0]).filter(Boolean)
    },
    onVideoSearchInput(val) {
      if (this.pForm.sourceType !== 'MIX_SET_TOPIC') {
        this.debouncedVideoSearch(val)
      }
    },
    /* 视频远程搜索（仅 VOD_SINGLE） */
    debouncedVideoSearch(val) {
      clearTimeout(this.videoSearchTimer)
      this.videoSearchTimer = setTimeout(() => this.videoSearch(val), 350)
    },
    videoSearch(val) {
      if (!val) { this.videoOptions = []; return }
      this.videoLoading = true
      get('/vod/questionnaire/video/search', { type: 'VOD_SINGLE', title: val, limit: 20 }).then(body => {
        this.videoOptions = body.data || []
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.videoLoading = false
      })
    },
    savePoint() {
      if (!this.selectedVideoIds.length) {
        this.$message.error(this.pForm.sourceType === 'MIX_SET_TOPIC' ? '请选择至少一个子视频' : '请选择视频')
        return
      }
      if (this.pForm.sourceType === 'MIX_SET_TOPIC' && !this.selectedTopicId) {
        this.$message.error('请先选择专题')
        return
      }
      if (!this.pForm.questionnaireId) {
        this.$message.error('请选择问卷')
        return
      }
      if (this.pForm.triggerTime == null || this.pForm.triggerTime < 0) {
        this.$message.error('请填写合法的触发秒数')
        return
      }
      const payload = {
        sourceType: this.pForm.sourceType,
        questionnaireId: this.pForm.questionnaireId,
        triggerTime: this.pForm.triggerTime
      }
      if (this.pForm.sourceType === 'MIX_SET_TOPIC') {
        // 专题组：多选子视频批量绑定
        payload.topicId = this.selectedTopicId
        payload.videoIds = this.selectedVideoIds
      } else {
        payload.sourceId = this.selectedVideoIds[0]
      }
      if (this.pModal.id) payload.id = this.pModal.id
      if (this.pModal.pointIds && this.pModal.pointIds.length) {
        payload.pointIds = this.pModal.pointIds
      }
      this.pModal.saving = true
      const req = this.pModal.id ? put('/vod/questionnaire/point', payload) : post('/vod/questionnaire/point', payload)
      req.then(() => {
        this.$message.success(this.pModal.id ? '点位已更新' : '点位已创建')
        this.pModal.visible = false
        this.loadPoints(this.pPage)
      }).catch(e => this.$message.error(e.message)).finally(() => {
        this.pModal.saving = false
      })
    },

    // 关闭抽屉（右上角 X / 遮罩）
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.vod-question-page { padding: 16px; }
.cfg-hint { font-size: 12px; color: #8b9aab; }
.mono { font-family: monospace; color: #5c6b7a; margin-left: 4px; font-size: 12px; }
.toolbar { margin-bottom: 12px; }
.vp-video-link { color: #1890ff; font-weight: 600; cursor: pointer; }
.vp-video-link:hover { text-decoration: underline; }
.vp-video-item { padding: 6px 0; border-bottom: 1px dashed #f0f0f0; }
</style>
